import {LOCALE_ID, NgModule} from "@angular/core";

import {AppComponent} from "./app.component";
import {AppRoutingModule} from "./app-routing.module";
import {BrowserModule} from "@angular/platform-browser";
import {FlexLayoutModule} from "@angular/flex-layout";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HttpClientModule} from "@angular/common/http";
import {LottieModule} from "ngx-lottie";
import {RouterModule} from '@angular/router';
import localeDEde from "@angular/common/locales/de";
import player from "lottie-web";
import {registerLocaleData} from "@angular/common";
import {ShellModule} from './modules/shell/shell.module';
import {NgSelectModule} from '@ng-select/ng-select';
import {AgmCoreModule} from '@agm/core';

registerLocaleData(localeDEde);

// Note we need a separate function as it's required
// by the AOT compiler.
export function playerFactory() {
    return player;
}

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule.withServerTransition({appId: 'serverApp'}),
        AppRoutingModule,
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        LottieModule.forRoot({player: playerFactory}),
        RouterModule,
        ShellModule,
        NgSelectModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyBBigBGhNHE616Hvpr4W8IUmpRtQiAKjMk&libraries=visualization,drawing',
            libraries: ['visualization', 'drawing'],
        })
    ],
    providers: [
        {provide: LOCALE_ID, useValue: "de-DE"},
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
}
